import { render } from "./ConsultDetail_AuditRisk.vue?vue&type=template&id=503b1c9a&scoped=true"
import script from "./ConsultDetail_AuditRisk.vue?vue&type=script&lang=js"
export * from "./ConsultDetail_AuditRisk.vue?vue&type=script&lang=js"

import "./ConsultDetail_AuditRisk.vue?vue&type=style&index=0&id=503b1c9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503b1c9a"]])

export default __exports__